export const experienceData = [
  {
    title: "Stress and Anxiety Relief",
    text: "Studies show that Ashwagandha can help lower cortisol levels, the hormone your body releases when you're stressed. People who take it regularly feel less stressed and experience a noticeable boost in their overall mental well-being.*",
    img: `${window.template_root}/v1/experience/1_StressAndAnxietyRelief.svg`,
  },
  {
    title: "Peaceful and Deep Sleep",
    text: "People who take Ashwagandha fall asleep faster, sleep more deeply, and wake up feeling more refreshed. According to recent research, it&apos;s a natural way to enjoy better, more restorative rest.*",
    img: `${window.template_root}/v1/experience/2_PeacefulAndDeepSleep.svg`,
  },
  {
    title: "Huge Immunity Boost",
    text: "Ashwagandha improves your body&apos;s natural defenses, making it easier to fight off infections. By supporting key immune cells, it helps keep you healthier and more resilient.*",
    img: `${window.template_root}/v1/experience/3_HugeImmunityBoost.svg`,
  },
  {
    title: "Mind, Body, and Hormone Balance",
    text: "Ashwagandha is a powerful herb that helps your body in various ways. It fights inflammation and oxidative stress, which can lead to a variety of health issues. It&apos;s also known for boosting mental clarity, reducing fatigue, and helping your hormones stabilize better.*",
    img: `${window.template_root}/v1/experience/4_MindBodyAndHormoneBalance.svg`,
  },
];
